// Copies the default body font-size in typography.scss
export const DEFAULT_FONT_SIZE_PX = 13
